import Marquee from "react-fast-marquee";

const OUTLETS = [
  "The Drew Barrymore Show",
  "CBS",
  "Elle",
  "The Hollywood Reporter",
  "Goop",
  "Lifetime",
  "Gaia",
  "Yahoo!",
  "Publishers Weekly",
  "Beverly Hills Film Festival",
  "Beyond the Grave",
];

export default function PressMarquee() {
  return (
    <section data-testid="press-marquee" className="border-y border-[#6B5D4F]/10 bg-[#F7F1E6] py-10">
      <p className="mb-6 text-center font-body text-[0.6rem] font-medium uppercase tracking-[0.5em] text-[#8B7D6B]">
        As featured on
      </p>
      <Marquee speed={32} gradient={false} pauseOnHover>
        {OUTLETS.map((o, i) => (
          <div key={o} className="mx-12 flex items-center gap-12 md:mx-16 md:gap-16">
            <span
              className={
                i % 2
                  ? "font-display text-2xl font-light italic text-[#6B5D4F]/85 md:text-4xl"
                  : "font-display2 text-2xl uppercase tracking-wide text-[#6B5D4F]/90 md:text-4xl"
              }
            >
              {o}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#C5A059]" aria-hidden="true" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
